class SelectionType {
    static ALL = 'all';
    static SINGLE = 'single';
    static MULTIPLE = 'multiple';
}

export default SelectionType
